import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { toast } from "react-toastify";
import { createAPIEndpointServiceInvoice, EndpointServiceInvoice } from "../../Services/ServiceInvoice/ServiceInvoiceService";
import { format } from "date-fns";

const Information = ({
    showDialog,
    setShowDialog,
    supplierName,
    strType,
    showGST,
    allRecordsData,
    setAllRecordsData,
    invoiceSSRCount,
    startDate,
    endDate,
    selectedSSRdetails,
    selectedSSR
}) => {
    const [amountBeforeTax, setAmountBeforeTax] = useState(0);
    const [igstAmount, setIgstAmount] = useState(0);
    const [cgstAmount, setcgstAmount] = useState(0);
    const [utgstAmount, setutgstAmount] = useState(0);
    const [totalAmt, setTotalAmt] = useState(0);
    const [amountdisable, setAmountdisable] = useState(true);
    const [selectedServiceDetails, setSelectedServiceDetails] = useState(null);
    const rowIndex = allRecordsData.length + 1;
    const normalInvoiceData = [
        { value: "1", label: "Business development charges" },
        { value: "2", label: "Business development expenses" },
        { value: "3", label: "Local activations" },
        { value: "4", label: "DAP expense service" },
        // { value: "5", label: "Handling charges" },
    ];
    const [formData, setFormData] = useState({
        row: rowIndex,
        Service_Details: selectedServiceDetails,
        Amount_Excluding_GST: amountBeforeTax,
        IGST_Amount: igstAmount,
        CGST_Amount: cgstAmount,
        SGST_UTGST_Amount: utgstAmount, // changes on 20/06/2025 regarding CGST calculation
        IGST: 18,
        CGST: 9,
        SGST_UTGST: 9,
        Total_Amount: totalAmt,
    });
    const [serviceDetailsOptions, setServiceDetailsOptions] = useState(
        supplierName?.NAME == "(SERCIL001) (SERVICE) CASTROL INDIA LIMITED"
            ? normalInvoiceData
            : normalInvoiceData.slice(-3)
    );
    const [RSEOptions,setRSEOptions] = useState([]);

    // const filteredOptionsfilteredOptions = supplierName?.NAME == "(SERCIL001) (SERVICE) CASTROL INDIA LIMITED" ? normalInvoiceData : normalInvoiceData.slice(-3);

    const handleChange = async() => {
        if (!selectedServiceDetails) {
            toast.error("Please select service detail", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return;
        }

        const newRecords = [];

        // ✅ Always add normal flow record
        const normalRecord = {
            ...formData,
            Amount_Excluding_GST: amountBeforeTax,
            Total_Amount: totalAmt,
            IGST_Amount: igstAmount,
            CGST_Amount: cgstAmount,
            SGST_UTGST_Amount: utgstAmount,
            IGST: igstAmount > 0 ? 18 : 0,
            CGST: cgstAmount > 0 ? 9 : 0,
            SGST_UTGST: utgstAmount > 0 ? 9 : 0,
        };
        newRecords.push(normalRecord);

        // ✅ If service is incentive, add second record too
        if (selectedServiceDetails === "1") {
            let strIncntv = ""; 
            console.log(selectedSSR,"sdgfyds");
            const response = await createAPIEndpointServiceInvoice().get(`${EndpointServiceInvoice.GetSSRIncentive}?SSRId=${selectedSSR?.CODE}&strStartDate=${format(startDate,"dd-MM-yyyy")}&strEndDate=${format(endDate,"dd-MM-yyyy")}`);
            strIncntv = response.data.Data[0]?.INCENTIVE;
            if (strIncntv && strIncntv !== "") {
                let incentive = parseFloat(strIncntv);
                let sutgstPerc = 0;
                let cgstPerc = 0;
                let igstPerc = 0;
                let m_igstAmnt = 0;
                let m_sutgstAmnt = 0;
                let m_cgstAmnt =0;
                if(showGST){
                    igstPerc = 18;
                    m_igstAmnt = (incentive * igstPerc) / 100;
                }
                else{
                    m_sutgstAmnt = (incentive * sutgstPerc) / 100;
                    m_cgstAmnt = (incentive * cgstPerc) / 100;
                }

                const totalAmt = (incentive + m_sutgstAmnt + m_cgstAmnt + m_igstAmnt);

                const incentiveRecord = {
                    ...formData,
                    Service_Details: "Other Development Charges",
                    Amount_Excluding_GST: incentive,
                    Total_Amount: totalAmt,
                    SGST_UTGST: sutgstPerc,
                    SGST_UTGST_Amount: m_sutgstAmnt.toFixed(2),
                    CGST: cgstPerc,
                    CGST_Amount: m_cgstAmnt.toFixed(2),
                    IGST: igstPerc,
                    IGST_Amount: m_igstAmnt.toFixed(2),
                };

                newRecords.push(incentiveRecord);
            }
        }

        console.log("newRecords",newRecords);
        setFormData(normalRecord); // keep latest edit in formData
        setAllRecordsData([...allRecordsData, ...newRecords]);
        setShowDialog(false);
    };


    const handleDropdownChange = (e) => {
        console.log(e.value);
        setSelectedServiceDetails(e.value);
        const foundObject = normalInvoiceData.find(
            (item) => item.value === e.value
        );
        if (foundObject?.value == "1") {
            console.log(startDate);
            console.log(endDate);
            if (strType == "S") {
                setAmountdisable(true);
            } else {
                setAmountdisable(false);
            }
            let roundedCharge = 0;
            if (startDate && endDate) {
                const start = new Date(startDate);
                const end = new Date(endDate);
                const startDay = start.getDate();
                const endDay = end.getDate();
                const maxDays = new Date(
                    end.getFullYear(),
                    end.getMonth() + 1,
                    0
                ).getDate();
                let ssrbdCharges;
                if (strType == "S") {
                    ssrbdCharges = selectedSSRdetails[0]?.BUSINESS_DEV_CHARGES;
                } else {
                    ssrbdCharges = 0;
                }

                if (strType === "S" && (endDay >= startDay)) {
                    const diffDays = endDay - startDay + 1;
                    const charge = (parseFloat(ssrbdCharges) / maxDays) * diffDays;
                    roundedCharge = Math.round(charge);
                    setAmountBeforeTax(roundedCharge.toString());
                } else if (strType === "S" && (endDay < startDay)) {
                    toast.warn("End Date Should Always Be Greater Than Start Date", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 3000,
                    });
                    setAmountBeforeTax("");
                }
            }
            handleTextChange(roundedCharge);
        } else {
            setAmountdisable(false);
        }
        if(strType==="R"){
            const foundObject = serviceDetailsOptions.find(
                (item) => item.value === e.value
            );
            setFormData((prevData) => ({
                ...prevData,
                Service_Details: foundObject?.label,
            }));
        }
        else{
            setFormData((prevData) => ({
                ...prevData,
                Service_Details: foundObject?.label,
            }));
        }
    };
    const handleAmtChange = (e) => {
        setAmountBeforeTax(e.target.value);
    };

    const handleTextChange = (beforeTax) => {
        const beforeTaxAmount = parseFloat(beforeTax);
        const txtCGSTprcnt = 9; // CGST Percentage
        const txtIGSTprcnt = 18; // IGST Percentage
        const txtSUTGSTprcnt = 9; // SUTGST Percentage
        // Check if beforeTax amount is greater than 0
        if (!isNaN(beforeTaxAmount) && beforeTaxAmount > 0) {
            const sutgstAmnt = (beforeTaxAmount * txtSUTGSTprcnt) / 100;
            const cgstAmnt = (beforeTaxAmount * txtCGSTprcnt) / 100;
            const igstAmnt = (beforeTaxAmount * txtIGSTprcnt) / 100;

            const totalAmount = Number(Number(beforeTaxAmount + sutgstAmnt + cgstAmnt + igstAmnt).toFixed(2));

            setutgstAmount(sutgstAmnt.toFixed(2));
            setcgstAmount(cgstAmnt.toFixed(2));
            setIgstAmount(igstAmnt.toFixed(2));
            setTotalAmt(totalAmount.toFixed(2));
        }
    };

    const calculateTaxes = () => {
        if (amountBeforeTax == 0) {
            setcgstAmount(0);
            setutgstAmount(0);
            setIgstAmount(0);
        }
        if (amountBeforeTax > 0) {
            if (showGST) {
                setIgstAmount(parseFloat(((18 / 100) * amountBeforeTax).toFixed(2)));
                setcgstAmount(0);
                setutgstAmount(0);
            } else {
                setIgstAmount(0);
                setcgstAmount(parseFloat(((9 / 100) * amountBeforeTax).toFixed(2)));
                setutgstAmount(parseFloat(((9 / 100) * amountBeforeTax).toFixed(2)));
            }
        }
    };
    const calculateTotalAmt = () => {
        if (amountBeforeTax == 0) setTotalAmt(0);
        if (amountBeforeTax > 0) {
            showGST
                ? setTotalAmt((Number(amountBeforeTax) + Number(igstAmount)).toFixed(2))
                : setTotalAmt(
                    (
                        Number(amountBeforeTax) +
                        (Number(cgstAmount) + Number(utgstAmount))
                    ).toFixed(2)
                );
        }
    };

    console.log("sdasdas", showGST);

    useEffect(() => {
        const getServiceDetailsRSE = async () => {
            if (strType == "R") {
                try {

                    const response = await createAPIEndpointServiceInvoice().get(
                        `${EndpointServiceInvoice.PopulateRSEServiceDetails}?ServiceType=RSE`
                    );
                    const filteredData = response.data.Data.map((val) => ({
                        value: val?.ID,
                        label: val?.SERVICE_DETAILS
                    }));
                    setServiceDetailsOptions(filteredData);
                    setRSEOptions(filteredData);
                }
                catch (e) {
                    console.log("Error", e);
                }
            }
        };
        getServiceDetailsRSE();
    }, [strType]);

    useEffect(() => {
        if (strType === "S") {
            let strisBDC = "";
            let filteredOptions = normalInvoiceData; // base data

            if (allRecordsData.length === 0) {
                setServiceDetailsOptions(normalInvoiceData);
            } else {
                // Check if "Business development charges" exists
                if (
                    allRecordsData.some(
                        (item) =>
                            item.Service_Details?.trim().toLowerCase() ===
                            "business development charges"
                    )
                ) {
                    strisBDC = "Y";
                }
                console.log("strisBDC", strisBDC);

                const existingDetails = allRecordsData.map((item) =>
                    item.Service_Details?.trim().toLowerCase()
                );

                // Filter out matching service labels
                filteredOptions = normalInvoiceData.filter(
                    (option) =>
                        !existingDetails.includes(option.label.trim().toLowerCase())
                );

                setServiceDetailsOptions(filteredOptions);
            }

            // Post-filter handling based on invoiceSSRCount
            if (invoiceSSRCount?.Data?.length > 0 && filteredOptions) {
                if (invoiceSSRCount.Data.length === 1) {
                    const desc = invoiceSSRCount.Data[0].SER_INVD_DESC?.trim().toLowerCase();

                    if (desc === "business development charges") {
                        setServiceDetailsOptions(filteredOptions?.filter(
                            (item) =>
                                item.label.trim().toLowerCase() !==
                                    "business development charges"
                        ));
                    } else if (desc === "business development expenses") {
                        setServiceDetailsOptions(
                            filteredOptions?.filter(
                                (item) =>
                                    item.label.trim().toLowerCase() !==
                                    "business development expenses"
                            )
                        );
                    }
                }
            }
        }
        else if(strType === "R"){
            let filteredOptions = RSEOptions; // base data

            if (allRecordsData.length === 0) {
                setServiceDetailsOptions(RSEOptions);
            } else {
                // Check if "Business development charges" exists

                const existingDetails = allRecordsData.map((item) =>
                    item.Service_Details?.trim().toLowerCase()
                );

                // Filter out matching service labels
                filteredOptions = serviceDetailsOptions.filter(
                    (option) =>
                        !existingDetails.includes(option.label.trim().toLowerCase())
                );

                setServiceDetailsOptions(filteredOptions);
            }

        }
    }, [invoiceSSRCount,RSEOptions]);


    

    useEffect(() => {
        calculateTaxes();
    }, [amountBeforeTax]);

    useEffect(() => {
        calculateTotalAmt();
    }, [igstAmount, utgstAmount, cgstAmount]);

    return (
        <>
            <Dialog
                header="Information"
                visible={showDialog}
                onHide={() => setShowDialog(false)}
                style={{ width: "60vw" }}
                closable={false}
                draggable={false}
                resizable={false}
                footer={() => {
                    return (
                        <div>
                            <div className="text-end">
                                <button
                                    type="button"
                                    className="btn btn-primary me-3"
                                    onClick={handleChange}
                                >
                                    Ok
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-cancel-red"
                                    onClick={() => setShowDialog(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    );
                }}
            >
                <div className="row">
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="d-block mb-2">
                            <label className="form-label d-block">Row</label>
                            <InputText
                                className="form-control"
                                value={allRecordsData.length + 1}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="d-block mb-2">
                            <label className="form-label d-block">Service Details</label>
                            <Dropdown
                                value={selectedServiceDetails}
                                options={serviceDetailsOptions} // Your options
                                onChange={handleDropdownChange} // Handler for change event
                                optionLabel="label"
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="d-block mb-2">
                            <label className="form-label d-block">Amount Before Tax</label>
                            <InputText
                                type="number"
                                className="form-control"
                                value={amountBeforeTax}
                                onChange={(e) => handleAmtChange(e)}
                                disabled={amountdisable}
                            />
                        </div>
                    </div>
                    {showGST && (
                        <>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="d-block mb-2">
                                    <label className="form-label d-block">IGST %</label>
                                    <InputText className="form-control" value="18%" disabled />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="d-block mb-2">
                                    <label className="form-label d-block">IGST Amount</label>
                                    <InputText
                                        className="form-control"
                                        value={igstAmount}
                                        disabled
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    {!showGST && (
                        <>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="d-block mb-2">
                                    <label className="form-label d-block">CGST %</label>
                                    <InputText className="form-control" value="9%" disabled />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="d-block mb-2">
                                    <label className="form-label d-block">CGST Amount</label>
                                    <InputText
                                        className="form-control"
                                        value={cgstAmount}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="d-block mb-2">
                                    <label className="form-label d-block">SGST/UTGST %</label>
                                    <InputText className="form-control" value="9%" disabled />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="d-block mb-2">
                                    <label className="form-label d-block">
                                        SGST/UTGST Amount
                                    </label>
                                    <InputText
                                        className="form-control"
                                        value={utgstAmount}
                                        disabled
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="d-block mb-2">
                            <label className="form-label d-block">Total Amount</label>
                            <InputText className="form-control" value={totalAmt} disabled />
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default Information;
